import React, { useEffect } from 'react';
import { useNavigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const Admin = () => {
  const { checkPermission } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're on the base /admin path
    if (location.pathname === '/admin') {
      // Check permissions and redirect to the first available admin section
      if (checkPermission('View Users')) {
        navigate('/admin/users');
      } else if (checkPermission('View Groups')) {
        navigate('/admin/groups');
      } else if (checkPermission('View Forms')) {
        navigate('/admin/forms');
      } else if (checkPermission('View Custom Pages')) {
        navigate('/admin/settings/custom-pages');
      } else if (checkPermission('View Custom Page Documents')) {
        navigate('/admin/settings/custom-documents');
      } else if (checkPermission('View Custom Page Submissions')) {
        navigate('/admin/settings/custom-menu-submissions');
      } else if (checkPermission('View Document Templates')) {
        navigate('/admin/settings/admin-document-generation');
      } else if (checkPermission('View Payment Settings')) {
        navigate('/admin/settings/payment-settings');
      } else if (checkPermission('View Client Types')) {
        navigate('/admin/settings/client-types');
      } else if (checkPermission('View Form Categories')) {
        navigate('/admin/settings/form-categories');
      } else if (checkPermission('View Products')) {
        navigate('/admin/settings/products');
      } else if (checkPermission('View Upload Fields')) {
        navigate('/admin/settings/upload-fields');
      } else if (checkPermission('View Verification Types')) {
        navigate('/admin/settings/verification-types');
      } else if (checkPermission('View Email Gateways')) {
        navigate('/admin/settings/email-gateways');
      } else if (checkPermission('View Email Templates')) {
        navigate('/admin/settings/email-templates');
      } else if (checkPermission('View Invoice Settings')) {
        navigate('/admin/settings/invoice-settings');
      } else if (checkPermission('View Blocks')) {
        navigate('/admin/settings/blocks');
      } else if (checkPermission('View Trademark Settings')) {
        navigate('/admin/trademark-settings');
      } else if (checkPermission('View Document Templates')) {
        navigate('/admin/admin-document-generation');
      } else if (checkPermission('Generate Documents')) {
        navigate('/admin/admin-document-generation/generate');
      } else if (checkPermission('View Admin Settings')) {
        // Check admin settings submenu permissions that require View Admin Settings
        if (checkPermission('View Admin Settings')) {
          navigate('/admin/settings/custom-id-settings');
        }
      } else {
        // If no permissions, redirect to dashboard
        navigate('/dashboard');
      }
    }
  }, [checkPermission, navigate, location.pathname]);

  return <Outlet />;
};

export default Admin; 